import { render, staticRenderFns } from "./IntentosSLA.vue?vue&type=template&id=4d29cb2c&scoped=true"
import script from "./IntentosSLA.vue?vue&type=script&lang=js"
export * from "./IntentosSLA.vue?vue&type=script&lang=js"
import style0 from "./IntentosSLA.vue?vue&type=style&index=0&id=4d29cb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29cb2c",
  null
  
)

export default component.exports